import React from "react";
import { FormControl, InputLabel, NativeSelect, FormControlLabel, Checkbox } from "@mui/material";
import { BootstrapInput } from "../edit-product/components/styles";
import CommonButtons from "src/shared/components/CommonButtons";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { ToastContainer } from "react-toastify";
import { Category } from "src/shared/services/interfacev2";

/* ---------- Props ---------- */
interface ProductToolbarProps {
  categories: Category[];
  categoryFilter: string;
  onCategoryChange: (value: string) => void;

  showDeletedProducts: boolean;
  onToggleDeleted: () => void;

  searchTerm: string;
  onSearchChange: (value: string) => void;

  onAddProduct: () => void;
}

/* ---------- Component ---------- */
const ProductToolbar: React.FC<ProductToolbarProps> = ({ categories, categoryFilter, onCategoryChange, showDeletedProducts, onToggleDeleted, searchTerm, onSearchChange, onAddProduct }) => {
  const { fontClass, borderHighlight } = useUserTheme();
  return (
    <div className="flex w-[94%] mt-[25px] mb-[15px]">
      <div className="w-full sm:w-[95%] lg:w-[100%] xl:w-[95%] 2xl:w-[88%] mx-auto rounded-lg py-[10px] px-5 min-h-[60px] justify-between grid grid-cols-1 sm:grid-cols-2 gap-4 xl:flex xl:flex-wrap xl:justify-end xl:items-center">
        {/* Category Filter */}
        <FormControl variant="standard">
          <InputLabel htmlFor="category-select">
            Search by category&nbsp;
            <span className="text-[#f04141] text-[15px]">*</span>
          </InputLabel>
          <NativeSelect sx={{ width: "300px" }} value={categoryFilter} onChange={(e) => onCategoryChange(e.target.value)} input={<BootstrapInput />}>
            <option value="all">All Categories</option>
            {categories.map((cat) => (
              <option key={cat._id.$oid} value={cat._id.$oid}>
                {cat.name}
              </option>
            ))}
          </NativeSelect>
        </FormControl>

        {/* Deleted Toggle */}
         <div onClick={(e) => e.stopPropagation()}>
           <FormControlLabel control={<Checkbox checked={showDeletedProducts} onChange={onToggleDeleted} /> } label="View deleted products" />
         </div>

          <div className="w-full max-w-[350px]">
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search by Product name"
            className={`w-full px-3 py-2.5 border rounded-md focus:outline-none focus:ring-2 ${borderHighlight} ${fontClass} text-sm text-black`}
          />
          {/* {searchTerm && (
            <IconButton
              size="small"
              onClick={() => onSearchChange("")}
              className="absolute right-1 top-1/2 -translate-y-1/2"
            >
              <Close fontSize="small" />
            </IconButton>
          )} */}
        </div>
        <div className="flex items-center" id="add-customer-btn">
          <CommonButtons className="w-44 h-10" label="ADD PRODUCT" onClick={onAddProduct} />
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover />
    </div>
  );
};

export default ProductToolbar;
